<template>
  <div class="create-account Profile">
    
  <section id="servicios" class="secciones seccion-blanca"> 
   <div class="container">
    <form class="" @submit.prevent="updateAccount">
     
      
      
      <div class="row">
        
      <div class="col-sm-12 col-md-8">
        <h2>Tu perfil: <strong>{{client_name + " " + client_lastname}}</strong></h2>  
       
         <div class="hrdivider">
          <hr/>
        </div>

        <div class="form-group">
          <div class="row">
            <div class="col-sm-2 form-col">
              <label class="control-label" for="firstName">Nombre *: </label>
            </div>
            <div class="col-sm-10">
              <input type="text" class="form-control" id="firstName" placeholder="Nombre*" v-model="client_name" maxlength="24" minlength="2" required>
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="row">
            <div class="col-sm-2 form-col">
              <label class="control-label" for="lastName">Apellido *: </label>
            </div>
            <div class="col-sm-10">
              <input type="text" class="form-control" v-model="client_lastname" id="lastName" placeholder="Apellido*" maxlength="24" minlength="2" required>
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="row">
            <div class="col-sm-2 form-col">
              <label class="control-label" for="lastName">DNI: </label>
            </div>
            <div class="col-sm-10">
              <input
                    type="text"
                    class="form-control"
                    id="dni"
                    placeholder="DNI"
                    maxlength="8"
                    pattern="[0-9]{8}" title="Sólo se permiten números. Debe ingresar un DNI válido." 
                    v-model="client_dni"></div>
          </div>
        </div>

        <div class="form-group">
          <div class="row">
            <div class="col-sm-2 form-col">
              <label class="control-label" for="lastName">Teléfono: </label>
            </div>
            <div class="col-sm-10">
              <input
                    type="text"
                    class="form-control"
                    id="phone"
                    placeholder="Teléfono"
                    maxlength="11"
                    pattern="[0-9]{7,11}" title="Sólo se permiten números. Debe ingresar un teléfono válido." 
                    v-model="cliente_phone"
                    >          </div>
          </div>
        </div>

        <div class="form-group">
          <div class="row">
            <div class="col-sm-2 form-col">
              <label class="control-label" for="lastName">Departamento: </label>
            </div>
            <div class="col-sm-10">
              <select v-model="cboDepartamento" id="basicSelect" :plain="true" @change="(event) => callProvincias(cboDepartamento,false)" class="form-control">
                    <option disabled value="">Seleccione Departamento</option>
                    <option v-for="depa in depas_array" :key="depa.id_departament" :value="depa.id_departament">{{depa.desc_departament}}</option>
              </select>      
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="row">
            <div class="col-sm-2 form-col">
              <label class="control-label" for="lastName">Provincia: </label>
            </div>
            <div class="col-sm-10">
               <select v-model="cboProvincia" id="basicSelect" :disabled="isdisabled" :required="isdisabled" :plain="true" @change="(event) => callDistritos(cboProvincia,false)" class="form-control">
                    <option disabled value="">Seleccione Provincia</option>
                    <option v-for="provincia in province_array" :key="provincia.id_province" :value="provincia.id_province">{{provincia.desc_province}}</option>
                </select>         
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="row">
            <div class="col-sm-2 form-col">
              <label class="control-label" for="lastName">Distrito: </label>
            </div>
            <div class="col-sm-10">
              <select v-model="cboDistrito" id="basicSelect" :disabled="isdisabled_distrito" :required="isdisabled_distrito" :plain="true" @change="(event) => enableDireccion()" class="form-control">
                    <option disabled value="">Seleccione Distrito</option>
                    <option v-for="distrito in distrito_array" :key="distrito.id_district" :value="distrito.id_district">{{distrito.desc_district}}</option>
              </select>      
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="row">
            <div class="col-sm-2 form-col">
              <label class="control-label" for="lastName">Dirección: </label>
            </div>
            <div class="col-sm-10">
              <input
                    type="text"
                    class="form-control"
                    v-model="client_address"
                    id="emailId"
                    placeholder="Dirección"
                    minlength="10"
                    maxlength="255"
                    :required="!isdisabled_direccion"
                    :disabled="isdisabled_direccion">
            </div>
          </div>
        </div>

        <p>¿Quieres cambiar tu contraseña? Cambiala <a data-toggle="modal" href="#myModalContraseña">aquí</a>.</p>
        <small><strong>NOTA: Solo los campos con asterísco (*) son obligatorios, sin embargo, si desea realizar una compra o un pedido online se le solicitará llenar todos los datos con la finalidad de brindarle un servicio adecuado.</strong></small>
            
          </div>

      <div class="col-sm-12 col-md-4">
                   
                      <form class="form-vertical">
                      <div class="form-group">
                        <div class="col-sm-12">
                          
                            <div class="fileinput fileinput-new" data-provides="fileinput">
                              <div class="fileinput-new" id="fileinput-foto">
                               <div class="card-image-product">
                                  <img class="rounded-circle image-cover img-thumbnail" v-if="url_image_preview" :src="url_image_preview" style="width:150px; height:150px;"/>
                                </div>
                               <!-- 
                                 <div class="card-image-product">
                                  <img class="rounded-circle image-cover img-thumbnail" v-if="url_image_preview" :src="imgPreUrl+'usuarios/empty-img.png'" style="width:150px; height:150px;"/>
                                </div>

                                 -->
                              </div>
                              <div>
                               
                              </div>
                            </div>
                          <div class="upload-msg"></div>
                           <span class="btn-al-md btn-al-verde-solid btn-secciones btn-file"><span class="fileinput-new">Selecciona una imagen</span>
                                <input type="file" name="fileToUpload" id="fileToUpload" @change="onFileChange" required="">
                                </span>
                          </div>
                    
                        </div>
                      </form>

                      <div>
                        
                      </div>
        </div>
      </div>
      <div class="col">
          <button class="btn-al btn-al-md btn-al-celeste-solid" type="submit">
                <i class="fa fa-spinner fa-spin mr-1" v-if="showLoader"></i>Actualizar mis datos
              </button>
            
      </div>
    </form>
    <div class="col" style="padding-top:10px;">
           <div :class="[(mensaje === '') ? 'd-none' : 'alert alert-success']" role="alert"><button type="button" class="close" data-dismiss="alert" @click="ocultar()">&times;</button><strong>{{ mensaje }}</strong></div>
           <div :class="[(mensaje_error === '') ? 'd-none' : 'alert alert-danger']" role="alert"><button type="button" class="close" data-dismiss="alert" @click="ocultar()">&times;</button><strong>{{ mensaje_error }}</strong></div>
    </div>
      <br>
      <br>

      <!-- MODAL -->    
    <div class="modal fade" id="myModalContraseña" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          
            <button type="button" class="btn-close-modern" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            
         
          <div class="modal-body">

            <form v-on:submit.prevent="changePassword">
              <h5 style="font-weight: bold;">Cambiar su contraseña</h5>
              <br>
              <div class="form-group">
                <label for="exampleFormControlFile1" style="text-align: left;">Antigua contraseña:</label>
                <input type="password" v-model="old_password" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Escriba su antigua contraseña" required autocomplete="off">
              </div>
              <hr/>
              <div class="form-group">
                <label for="exampleFormControlFile2" style="text-align: left;">Nueva contraseña:</label>
                <input type="password" v-model="new_password" class="form-control" id="exampleInputEmail2" aria-describedby="name" placeholder="Escriba una nueva contraseña" required autocomplete="off">
              </div>

              <div class="form-group">
                <label for="exampleFormControlFile3" style="text-align: left;">Confirmar nueva contraseña:</label>
                <input type="password" v-model="confirm_password" class="form-control" id="exampleInputEmail3" aria-describedby="name" placeholder="Confirme su nueva contraseña" required autocomplete="off">
              </div>

              <br>
              
              <button type="submit" class="btn-al btn-al-lg btn-al-celeste-solid btn-secciones">Actualizar</button>
              <button type="button" class="btn-al btn-al-lg btn-al-rojo-solid btn-secciones" data-dismiss="modal">Cancelar</button>
              
            </form>

            <br>
            <div :class="[(mensaje_contraseña === '') ? 'd-none' : 'alert alert-success']" role="alert"><button type="button" class="close" data-dismiss="alert" @click="ocultar_msjpwd()">&times;</button><strong>{{ mensaje_contraseña }}</strong></div>
            <div :class="[(mensaje_error_contraseña === '') ? 'd-none' : 'alert alert-danger']" role="alert"><button type="button" class="close" data-dismiss="alert" @click="ocultar_msjpwd()">&times;</button><strong>{{ mensaje_error_contraseña }}</strong></div>
          
          </div>
        </div>
      </div>
    </div>

    </div>
   </section>
   <TwoModules></TwoModules>
  <News></News>
  </div>
</template>

<script>
import TwoModules from "@/components/products/TwoModules.vue";
import News from "@/components/products/Guia.vue";
import Vue from 'vue'
import toastr from 'toastr'
import axios from 'axios'
import { successToaster, errorToaster } from "@/components/shared/service/ErrorHandler.js";
import {config_settings} from '@/config.js'

  //HTTP ERROR STATUS
  const NOT_FOUND = 404;
  const BAD_REQUEST = 400;
  const UNAUTHORIZED = 401;
  const CONFLICT = 409;
  const INTERNAL_SERVER_ERROR = 500;

 axios.interceptors.response.use(function (response) { return response; }, 
  function (error) {
    
    if(error.message === 'Network Error'){
      toastr.error("No se puede conectar con el servidor. Verifique su conexión a internet",
                       "ERROR",
                       {"iconClass": 'customer-danger'});
    }
    else if(error.response.status === UNAUTHORIZED){
      if(error.response.data.message === "Access is denied"){
         toastr.error("Usted no tiene los provilegios para acceder a esta sección",
                       "ERROR",
                       {"iconClass": 'customer-danger'});
      }
      else {
        return Promise.reject(error);
      }
    }
    else {
      return Promise.reject(error);
    }
});

export default {
  name: "CreateAccount",
  created() {
    this.scroll_inicio();
    this.get_puser_data();
    this.callDepartamentos();
  },
  data() {
    return {
      imgPreUrl : config_settings.PHOTO_SERVER_URL+'/',
      url_image_preview: config_settings.PHOTO_SERVER_URL+'/clients/empty-img.jpg',
      image_portada: config_settings.PHOTO_SERVER_URL+'/clients/empty-img',
      mensaje: "",
      mensaje_error: "",
      showLoader: false,
      client_email: "",
      client_username: "",
      client_password: "",
      client_name: "",
      client_lastname: "",
      client_dni: "",
      cliente_phone: "",
      cboDepartamento: "",
      cboProvincia: "",
      cboDistrito: "",
      client_address: "",
      cboDepartamento: "",
      cboDistrito: "",
      depas_array: [],
      province_array: [],
      distrito_array: [],
      isdisabled: true,
      isdisabled_distrito: true,
      isdisabled_direccion: true,
      token: localStorage.getItem('access_token'),
      refresh_token: localStorage.getItem('refresh_token'),
      image_data: "",
      old_password: "",
      new_password: "",
      confirm_password: "",
      mensaje_contraseña: "",
      mensaje_error_contraseña: ""
    }
  },
  components: { TwoModules,
    News},
  methods: {

    ocultar_msjpwd() {
      this.mensaje_contraseña = ""
      this.mensaje_error_contraseña = ""
    },

    reset_form_password() {
      this.new_password = ""
      this.old_password = ""
      this.confirm_password = ""
    },

    scroll_inicio(){
      window.scrollTo(0,0);
    },

    changePassword() {
      var json_data = {
        "new_password_client" : this.new_password,
        "old_password_client" : this.old_password
      }

      if(this.new_password == this.confirm_password) {
        axios({
          method: 'PUT',
          url: config_settings.RESOURCE_SERVER_URL+'/PUT/password',
          data: json_data,
          headers: {
            Authorization: "Bearer " + localStorage.getItem('access_token')
          }
        })
        .then(response => {
          this.mensaje_error_contraseña = ""
          this.mensaje_contraseña = "La contraseña ha sido modificada exitosamente."
          this.reset_form_password()
        })
        .catch(error => {
          if(error.response.status === UNAUTHORIZED){
            this.refreshToken().then(_ => {
            this.changePassword();
            })
            .catch(_ => {
            toastr.error("Debe iniciar sesión antes de continuar",
                        "Error",
                        {"iconClass": 'customer-danger'});
            this.mensaje_error = "Debe iniciar sesión antes de continuar";
            this.mensaje = "";
                        this.$router.push({path: '../../../login/'})
            });
          }
          else {
            toastr.error(error.response.data.details,
                        error.response.data.message,
                        {"iconClass": 'customer-danger'});
          

            this.mensaje_contraseña = ""
            this.mensaje_error_contraseña = "La contraseña actual ingresada no es la correcta. Por favor, inténtelo nuevamente."
            this.reset_form_password()
          }  
        })
      }
      else {
        this.mensaje_contraseña = ""
        this.mensaje_error_contraseña = "Los campos de nueva contraseña no coinciden. Por favor asegúrese que sean las misma."
      }
    },

    onFileChange(e) {
      const file = e.target.files[0];
      this.image_data = file;
      this.url_image_preview = URL.createObjectURL(file);
    },

    refreshToken(){
          var refresh_token = localStorage.getItem('refresh_token');
          var refresh_credentials = new FormData();
          refresh_credentials.append('grant_type', 'refresh_token');
          refresh_credentials.append('refresh_token',  refresh_token);
          refresh_credentials.append('id_store',  config_settings.STORE);

          const refreshingCall = axios({
            method: 'post',
            url: config_settings.AUTH_SERVER_URL+'/oauth/token',
            data: refresh_credentials,
            withCredentials: true,
            auth: {
                username: 'USER_CLIENT_APP',
                password: 'password'
            }})
            .then(response => {
              localStorage.setItem('access_token', response.data.access_token);
              localStorage.setItem('refresh_token', response.data.refresh_token);
              return Promise.resolve(true);
            });
            return refreshingCall;
    },

     get_puser_data() {
      axios({
        method: 'get',
        url: config_settings.RESOURCE_SERVER_URL+'/GET/profile',
        headers: {
          Authorization: "Bearer " + localStorage.getItem('access_token')
        }
      })
      .then(response => {
        this.image_portada = config_settings.PHOTO_SERVER_URL+"/"+response.data.photo_client;
        this.url_image_preview = config_settings.PHOTO_SERVER_URL+"/"+response.data.photo_client+".jpg";
        this.client_email = response.data.email_client
        this.client_username = response.data.nick_client
        this.client_name = response.data.name_client
        this.client_lastname = response.data.surname_client
        this.client_dni = response.data.dni_client
        this.cliente_phone = response.data.phone_client
        this.client_address = response.data.address_client
        this.callDepartamentos();
        var cboDistrito =  response.data.id_district.id_district;
        if(cboDistrito!=0){
          this.cboDistrito =  response.data.id_district.id_district;
          this.callUbigeo (this.cboDistrito);
        }
        else {
          this.cboDistrito = "";
        }
      })
      .catch(error => {
        if(error.response.status === UNAUTHORIZED){
           this.refreshToken().then(_ => {
           this.get_puser_data();
           })
           .catch(_ => {
           toastr.error("Debe iniciar sesión antes de continuar",
                       "Error",
                       {"iconClass": 'customer-danger'});
           this.mensaje_error = "Debe iniciar sesión antes de continuar";
           this.mensaje = "";
                       this.$router.push({path: '../../../login/'})
           });
         }
         else {
           toastr.error(error.response.data.details,
                       error.response.data.message,
                       {"iconClass": 'customer-danger'});
         }  
      })
    },
    
    //CAMBIAR SERVICIO
     uploadPhoto() {
      var form = new FormData();
      form.append('file',this.image_data);
      axios({
        method: 'post',
        url: config_settings.RESOURCE_SERVER_URL+'/POST/profile/photo',
        data: form,
        headers: {
          Authorization: "Bearer " + localStorage.getItem('access_token')
        }
      })
      .then(response => {
        this.mensaje = '¡Exito!, su foto ha sido actualizada correctamente.';
        this.mensaje_error = "";
        this.image_data = "";  
        
      })
      .catch(error => {
       if(error.response.status === UNAUTHORIZED) {
           this.refreshToken().then(_ => {
           this.uploadPhoto();
           })
           .catch(_ => {
           toastr.error("Debe iniciar sesión antes de continuar",
                       "Error",
                       {"iconClass": 'customer-danger'});
                       this.$router.push({path: '../../../login/'})
           });
         }
         else {
           this.mensaje = "";
           this.mensaje_error = 'Su perfil fue actualizado correctamente en el sistema pero no se pudo subir su nueva foto correctamente al servidor. El sistema solo acepta fotos en formato .jpg y .png, verifique los datos e inténtelo nuevamente.'
            console.log(error.response.data.message);
        //  toastr.error(error.response.data.details,
         //              error.response.data.message,
         //              {"iconClass": 'customer-danger'});
           
         }  
      })
    },

    callUbigeo (cboDistrito) {
      axios({
        method: 'get',
        url: config_settings.RESOURCE_SERVER_URL+'/GET/locations/'+cboDistrito,
        headers: {
          Authorization: "Bearer " + localStorage.getItem('access_token')
        }
      })
      .then(response => {
        this.cboDepartamento = response.data.departament.id_departament
        
        this.callProvincias (response.data.departament.id_departament,true)
        this.cboProvincia = response.data.province.id_province
        this.callDistritos (response.data.province.id_province,true)
        this.isdisabled_direccion = false
      })
      .catch(error => {
        if(error.response.status === UNAUTHORIZED){
           this.refreshToken().then(_ => {
           this.callUbigeo (cboDistrito);
           })
           .catch(_ => {
            toastr.error("Debe iniciar sesión antes de continuar",
                       "Error",
                       {"iconClass": 'customer-danger'});
           this.mensaje_error = "Debe iniciar sesión antes de continuar";
           this.mensaje = "";
           this.$router.push({path: '../../../login/'})
           });
         }
         else {
           toastr.error(error.response.data.details,
                       error.response.data.message,
                       {"iconClass": 'customer-danger'});
         }  
      })
    },

    updateAccount() {
      this.showLoader = true;
      var distrito_json = ""
      var direccion_json = " "
      var dni_json = " "
      var phone_json = " "

      this.cboDistrito != "" ? distrito_json = { "id_district" : this.cboDistrito } : distrito_json = { "id_district" : null };
      this.client_address != "" ? direccion_json = this.client_address : direccion_json = " "
      this.client_dni != "" ? dni_json = this.client_dni : dni_json = null
      this.cliente_phone != "" ? phone_json = this.cliente_phone : phone_json = null

      var json_data = {
           "nick_client" : this.client_username,
          "dni_client" : dni_json,
          "name_client": this.client_name,
          "surname_client": this.client_lastname,
          "address_client": direccion_json,
          "email_client": this.client_email,
          "phone_client": phone_json,
          "id_district": distrito_json,
          "state": {
              "id_state": 1
          }
      }

      axios({
        method: 'put',
        url: config_settings.RESOURCE_SERVER_URL+'/PUT/profile',
        headers: {
          Authorization: "Bearer " + localStorage.getItem('access_token')
        },
        data: json_data
      })
      .then(response => {

        if(this.image_data != ""){
          this.mensaje =  "Sus datos fueron actualizados. Subiendo su nueva foto al servidor..."
          this.uploadPhoto();
          this.mensaje_error = "";
        }
        else {
          this.mensaje = "Sus datos han sido actualizados correctamente";
          this.mensaje_error = "";
        }
      })
      .catch(error => {
        if(error.response.status === CONFLICT){
          this.mensaje_error = "El nombre de usuario o el e-mail que desea registrar ya existe en la base de datos.";
        }
        else if(error.response.status === BAD_REQUEST){
          this.mensaje_error = "Ingrese correctamente los datos solicitados.";
        }
        else {
          this.mensaje_error = "Se ha producido un error. Inténtelo nuevamente.";
        }
        this.mensaje = "";
                       
      })

      this.showLoader = false;
    },

    reset_view() {
      this.showLoader = false,
      this.client_email = "",
      this.client_username = "",
      this.client_password = "",
      this.client_name = "",
      this.client_lastname = "",
      this.client_dni = "",
      this.cliente_phone = "",
      this.cboDepartamento = "",
      this.cboProvincia = "",
      this.cboDistrito = "",
      this.client_address = "",
      this.cboDepartamento = "",
      this.cboDistrito = "",
      this.isdisabled = true,
      this.isdisabled_distrito = true,
      this.isdisabled_direccion = true
    },

    callDepartamentos () {
      axios({
        method: 'get',
        url: config_settings.RESOURCE_SERVER_URL+'/GET/locations/departments',
      })
      .then(response => {
        this.depas_array = response.data
      })
      .catch(error => {
        
      })
    },

    callProvincias (cboDepartamento, component_start) {
      axios({
        method: 'get',
        url: config_settings.RESOURCE_SERVER_URL+'/GET/locations/departaments/'+cboDepartamento+'/provinces',
      })
      .then(response => {
        this.province_array = response.data
        if(component_start == false){
          this.cboProvincia = ""
          this.cboDistrito = ""
          this.isdisabled_distrito = true
          this.client_address = ""
          this.isdisabled_direccion = true
        }
        this.isdisabled = false
      })
      .catch(error => {
        if(error.response.status === UNAUTHORIZED){
           this.refreshToken().then(_ => {
           this.callProvincias(cboDepartamento, component_start);
           })
           .catch(_ => {
           toastr.error("Debe iniciar sesión antes de continuar",
                       "Error",
                       {"iconClass": 'customer-danger'});
                      this.$router.push({path: '../../../login/'})
           });
         }
         else {
           toastr.error(error.response.data.details,
                       error.response.data.message,
                       {"iconClass": 'customer-danger'});
         }  
      })
    },

    callDistritos (cboProvincia, component_start) {
      axios({
        method: 'get',
        url: config_settings.RESOURCE_SERVER_URL+'/GET/locations/departments/provinces/'+cboProvincia+'/districts',
      })
      .then(response => {
        this.distrito_array = response.data
        if(component_start == false){
            this.cboDistrito = ""
        }
        this.isdisabled_distrito = false
      })
      .catch(error => {
       if(error.response.status === UNAUTHORIZED){
           this.refreshToken().then(_ => {
           this.callDistritos(cboProvincia, component_start);
           })
           .catch(_ => {
           toastr.error("Debe iniciar sesión antes de continuar",
                       "Error",
                       {"iconClass": 'customer-danger'});
                       this.$router.push({path: '../../../login/'})
           });
         }
         else {
           toastr.error(error.response.data.details,
                       error.response.data.message,
                       {"iconClass": 'customer-danger'});
         }  
      })
    },

    enableDireccion(){
      this.isdisabled_direccion = false;
    },

    ocultar(){
       this.mensaje=""
       this.mensaje_error=""
    }
  }
};
</script>

<style lang="scss" src="./Profile.scss"></style>
